/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// fix cartier link opening shopping cart

// document.addEventListener("DOMContentLoaded", function(event) {
//   console.log('cartier')
//   console.log(document.querySelector('[href="/collections/cartier-watches"]'))
//   document.querySelector('[href="/collections/cartier"]').removeEventListener('click');
// });

async function createGIF() {
  const loadImage = async (img) => {
    return new Promise((resolve, reject) => {
      img.onload = async () => {
        resolve(true);
      };
    });
  };

  const height = 720;
  const width = 600;

  const encoder = new GIFEncoder();
  encoder.setRepeat(0); //0  -> loop forever, 1+ -> loop n times then stop
  encoder.setDelay(1000); //go to next frame every n milliseconds
  encoder.setSize(width, height);
  encoder.start();

  const productImages = document.querySelectorAll(".Product__SlideItem--image.Carousel__Cell img");

  productImages.forEach(async (imageEl) => {
    imageEl.src = imageEl.dataset.originalSrc;
    await loadImage(imageEl);

    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;

    const context = canvas.getContext("2d");
    context.fillStyle = "white";
    context.fillRect(0, 0, canvas.width, canvas.height);
    // context.imageSmoothingQuality = "high";

    const logoEl = document.querySelector(".Header__LogoImage--primary");
    context.drawImage(logoEl, canvas.width / 2 - 184, 50, 368, 65);
    context.drawImage(imageEl, 50, 160, 500, 500);
    // context.translate(0.5, 0.5);

    // context.color = 'black';
    // context.font = "normal 22px Nunito Sans";
    // // context.rotate(-);
    // context.fontStyle = 'normal';
    // context.letterSpacing = '0.2em';
    // context.textAlign = 'center';
    // context.textBaseline = 'middle';
    // context.fillStyle = 'black';
    // context.fillText("ESTATE WATCH & JEWELRY CO.", (canvas.width / 2), 80);
    // context.textTransform = 'uppercase';
    encoder.addFrame(context);
  });

  setTimeout(() => {
    encoder.finish();
    encoder.download("jewelry.gif");
  }, 1500);
}

document.addEventListener("DOMContentLoaded", function (event) {
  if (document.querySelector(".ProductMeta__Description")) {
    const downloadShare = document.createElement("a");
    downloadShare.classList.add("ProductMeta__ShareTitle");
    downloadShare.classList.add("Heading");
    downloadShare.classList.add("Text--subdued");
    downloadShare.classList.add("u-h7");
    downloadShare.style.fontSize = "11px";
    downloadShare.style.cursor = "pointer";
    downloadShare.style.display = "block";

    downloadShare.innerHTML = "Download";
    downloadShare.addEventListener("click", createGIF);
    document.querySelector(".Product__Info").appendChild(downloadShare);
  }

  const phone = document.querySelectorAll('[rel="phone"]');
  phone.forEach(function (el) {
    el.addEventListener("click", (e) => {
      fbq("track", "Call");
    });
  });

  var maxMilliseconds = 60 * 1000; // make sure the visitor doesn't receive a reply within 60 seconds
  var replyTimer = null;
});
